import { type ComponentProps, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type AssetVersionProps = ComponentProps<'div'> & {
  state: 'default' | 'active';
};

export const AssetVersion = memo(
  forwardRef<HTMLDivElement, AssetVersionProps>(({ className, state = 'default', ...restOfProps }, ref) => {
    return (
      <div
        className={cn(
          'group/asset-version relative flex h-14 w-full cursor-pointer select-none items-center gap-2 rounded-8 bg-transparent px-2 py-0 ads:text-primary text-gray-12 ring-2 ring-transparent ring-inset transition-colors ads:hover:bg-hover-subtle hover:bg-gray-3 ads:data-[state=active]:bg-raised data-[state=active]:bg-gray-2 ads:data-[state=active]:ring-primary data-[state=active]:ring-blue-9 ads:data-[state=active]:hover:bg-hover-subtle data-[state=active]:hover:bg-gray-3',
          className,
        )}
        data-testid="ASSET_VERSION"
        data-state={state}
        // biome-ignore lint/a11y/noNoninteractiveTabindex: We want to make this element selectable by keyboard without this being a button to prevent invalid DOM nesting. We could do the inset-0 button instead but that causes issues with the drag and drop functionality.
        tabIndex={0}
        {...restOfProps}
        ref={ref}
      />
    );
  }),
);

AssetVersion.displayName = 'AssetVersion';
